import {Component, Inject, inject} from '@angular/core';
import {MatInputModule} from '@angular/material/input';
import {TextButton} from '../../../../shared/components/text-button/text-button.component';
import {TranslocoPipe, TranslocoService} from '@jsverse/transloco';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MAT_DIALOG_DATA, MatDialogClose, MatDialogRef} from '@angular/material/dialog';
import {FormControl, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {AppointmentDto} from '../../../../shared/dtos/appointment.dto';
import {CustomValidators} from '../../../../shared/validators/custom-validators';
import {PatientManagementService} from '../../patient-management.service';
import {ErrorService} from '../../../../core/services/error.service';
import {HttpErrorResponse} from '@angular/common/http';
import {DatePipe} from '@angular/common';
import {CustomDatePipe} from '../../../../shared/pipes/custom-date-pipe';

@Component({
  selector: 'app-cancel-appointment',
  imports: [
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    TextButton,
    TranslocoPipe,
    FormsModule,
    ReactiveFormsModule,
    CustomDatePipe,
    MatDialogClose
  ],
  templateUrl: './cancel-appointment.dialog.html',
  styleUrl: './cancel-appointment.dialog.scss'
})
export class CancelAppointmentDialog {
  dialogRef = inject(MatDialogRef<CancelAppointmentDialog>);
  patientManagementService = inject(PatientManagementService);
  translocoService = inject(TranslocoService);
  errorService = inject(ErrorService);

  cancellationReasonForm = new FormControl("", [Validators.required, CustomValidators.whiteSpace]);

  constructor(@Inject(MAT_DIALOG_DATA) public data: { appointmentDto: AppointmentDto }) {
  }

  cancelAppointment() {
    this.cancellationReasonForm.markAllAsTouched();
    if (this.cancellationReasonForm.invalid) {
      return;
    }

    const cancellationReason = this.cancellationReasonForm.value!;
    const appointmentCancelDto = {
      appointmentId: this.data.appointmentDto.appointmentId,
      cancellationReason: cancellationReason,
    }
    this.patientManagementService.cancelAppointment(appointmentCancelDto).subscribe({
      next: () => {
        this.dialogRef.close(true);
      },
      error: (error: HttpErrorResponse) => {
        this.errorService.handleError(error, this.translocoService.translate('error.title.cancel'));
      }
    })
  }
}
